// extracted by mini-css-extract-plugin
module.exports = {"waiting":"waiting-TWg8s"};